// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary-module--summary--Mq2He","item":"Summary-module--item--ZDQai","comingsoon":"Summary-module--comingsoon--2Zab6"};